import { AgGridReact, ChangeDetectionStrategyType } from 'ag-grid-react';
import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import './EditContextList.scss';
import { useSelector } from 'react-redux';
import {
  editModelList,
  getEditModelList,
  getModelEditLoading,
  getModalListDetailsLoading,
  listModelDetails,
  updateModelName,
  modelTableauDetails,
  setCurrentUniqueId
} from 'src/slices/contextSlice';
import { GridReadyEvent, ICellRendererParams } from 'ag-grid-community';
import './ContextPage.scss';
import { Button, Input, Loader, Pagination, SidebarLayout, TextArea, Icon ,Tooltip} from '@scuf/common';
import useWindowSize from 'src/utils/useWindowSize';
import { CustomOverlay, StatusRenderer } from './ContextPage';
import { useAppDispatch } from 'src/store';
import { StageOne } from 'src/pages/contextPage/stages/StageOne';
import { StageTwo } from 'src/pages/contextPage/stages/StageTwo';
import { StageWithQuestions } from 'src/pages/contextPage/stages/StageWithQuestions';
import { SetActiveStage } from 'src/pages/contextPage/stages/SetActiveStage';
import { DataContextModal } from 'src/components/DataContextModal/DataContextModal';
import { useNavigate } from 'react-router-dom';//new
import { RouteConstants } from 'src/constants/routeConstants'; //new


type InitialQuestionDataProps = {
  question_id?: number;
  question_name: string;
  question_options: string[];
  preferrable_ans: string;
  is_new: boolean;
};


type ModelHighLevelDataProps = {
  model_id: number;
  model_name: string;
  active_stage: number;
  module_id: number;
  module_name: string;
};

type InitialModelDataProps = {
  model_id: number;
  model_name: string;
  stage_id: number;
  stage_name: string;
  tableau_link: string;
  question: InitialQuestionDataProps[];
  module_id: number;
  module_name: string;
};


export const EditContextList: FC<{}> = () => {
  const dispatch = useAppDispatch();
  const editLoading = useSelector(getModalListDetailsLoading);
  const gridRef = useRef<any>(null);
  const [gridEvent, setGridEvent] = useState<GridReadyEvent>();
  const gridApi = useMemo(() => gridEvent?.api, [gridEvent]);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [highLevelModalData, setHighLevelModalData] = useState<Partial<ModelHighLevelDataProps>>({});
  const [modelDetailData, setModelDetailData] = useState<any>({});
  const { width } = useWindowSize();
  const [activeName, setActiveName] = useState("0-Setup");
  const [refreshScreen, setRefreshScreen] = useState(false);
  const [createNewModel, setCreateNewModel] = useState<boolean>(false);
  const [demoModelOpen, setDemoModelOpen] = useState<boolean>(false);
  const [demouniqueID, setDemouniqueID] = useState("");
  const [demoStageID, setDemoStageID] = useState<number>(0);
  const nevigate = useNavigate() //new


  const {
    model_details: rowData,
    metadata: { page_limit, page, total_row_count },
    loading: gridLoading,
    error: gridError,
  } = useSelector(getEditModelList);


  const uniqueKeyExists = (stageObj: any, value: number) => {
    const isFound = stageObj.some((element: any) => {
      if (element.stage_id === value) {
        if (element.unique_id !== null)
          return true;
      } else return false;
    });
    return isFound;
  }

  const handleDemoPopUpClose = () => {
    setDemoModelOpen(false);
  }

  const handleClose = () => {
    setModalOpen(false);
    setCreateNewModel(false)
  };

  const onCreateNewModel = () => {
    setRefreshScreen(!refreshScreen)
    setCreateNewModel(!createNewModel)
    setActiveName("0-Setup")
  }

  const refreshEditScreen = () => {
    setRefreshScreen(!refreshScreen)
  }

  const onEditClick = useCallback((data: InitialModelDataProps) => {
    nevigate(`${RouteConstants.CONTEXT_EDIT}/${data?.model_id}`) //new
    setHighLevelModalData(data);
    setModalOpen(true);
  }, []);

  const onDemoClick = useCallback((data: any, stage: number) => {
    setHighLevelModalData(data);
    // setModalOpen(true);
    const clickedStageObj = data.stage_details.find((element: any) => {
      return element.stage_id === stage;
    });
    setDemouniqueID(clickedStageObj.unique_id);
    setDemoStageID(stage);
    setDemoModelOpen(true);

    dispatch(
      modelTableauDetails({
        unique_id: clickedStageObj.unique_id,
        model_id: data.model_id,
        stage_id: stage,
        is_demo:true
      })
    );
    dispatch(setCurrentUniqueId(clickedStageObj.unique_id));


  }, []);

  useEffect(() => {
    if (createNewModel) {
      setModalOpen(true)
    }

  }, [createNewModel]);


  useEffect(() => {
    dispatch(listModelDetails({
      "model_id": highLevelModalData.model_id,
      "module_id": highLevelModalData.module_id
    })).then((response: any) => {

      setModelDetailData(response.payload);

    })
  }, [modalOpen, refreshScreen]);


  // const ActionRender = useCallback(
  //   (params: ICellRendererParams) => {
  //     return (
  //       <span
  //         className='training-chip'
  //         onClick={() => onEditClick(params.data)}>
  //         Edit
  //       </span>
  //     );
  //   },
  //   [onEditClick]
  // );

  const ActionRender = useCallback(
    (params: ICellRendererParams) => {
      const buttonStyle = {
        background: 'linear-gradient(144.82deg, #0072c2 5.58%, #1792e5 93.38%)',
        borderRadius: '1rem',
        color: '#fff',
        cursor: 'pointer',
        padding: '0.2rem 0.5rem',
      };
      return (
  <span
          style={buttonStyle}
          onClick={() => onEditClick(params.data)}
  >  
 Edit
  </span>
      );
    },
    [onEditClick]
  );

  const ActionLabeling = useCallback(
    (params: ICellRendererParams) => {

      return (
        <>
          {
            params.data.stage_details == null ? null :
              uniqueKeyExists(params.data.stage_details, 2) ?
              <span
                className='training-chip'
                onClick={() => onDemoClick(params.data, 2)}>
                2
              </span>:
               <span
               className='completed-chip'
              >
               2
             </span>
          }

        </>

      );
    },
    [onDemoClick]
  );

  const ActionTuning = useCallback(
    (params: ICellRendererParams) => {
      return (
        <>
          {
            params.data.stage_details == null ? null :
              uniqueKeyExists(params.data.stage_details, 3) ?
              <span
                className='training-chip'
                onClick={() => onDemoClick(params.data, 3)}>
                3
              </span>:
              <span
              className='completed-chip'
             >
              3
            </span>
          }
        </>

      );
    },
    [onDemoClick]
  );



  const ActionDelivery = useCallback(
    (params: ICellRendererParams) => {
      return (
        <>
          {
            params.data.stage_details == null ? null :
              uniqueKeyExists(params.data.stage_details, 4) &&
              <span
                className='training-chip'
                onClick={() => onDemoClick(params.data, 4)}>
                4
              </span>
          }
        </>

      );
    },
    [onDemoClick]
  );

  const ActionSetup = useCallback(
    (params: ICellRendererParams) => {
      return (
        <>
          {
            params.data.stage_details == null ? null :
              uniqueKeyExists(params.data.stage_details, 1) &&
              <span
                className='training-chip'
                onClick={() => onDemoClick(params.data, 1)}>
                1
              </span>
          }

        </>

      );
    },
    [onDemoClick]
  );

  // const ActionDisabled = useCallback(
  //   (params: ICellRendererParams) => {
  //     return (
  //       <span
  //         className='training-chip'
  //         onClick={() => onEditClick(params.data)}
  //         >
  //         1
  //       </span>
  //     );
  //   },
  //   [onEditClick]
  // );

  const CustomOverlayParams = useMemo(() => {
    return {
      loading: gridLoading,
      noRecords: rowData.length === 0,
      error: gridError,
    };
  }, [gridError, gridLoading, rowData.length]);

  const onGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit();
    setGridEvent(event);
  };

  const onPageChange = (page: number | string) => {
    dispatch(editModelList({ page }));
  };


  useEffect(() => {
    gridApi?.sizeColumnsToFit();
  }, [gridApi]);

  useEffect(() => {
    dispatch(editModelList({}));
  }, [dispatch, modalOpen]);

  useEffect(() => {
    gridApi?.sizeColumnsToFit();
  }, [gridApi, width]);

  useEffect(() => {
    if (gridLoading) gridApi?.showLoadingOverlay();
    else if (rowData.length === 0 || gridError) gridApi?.showNoRowsOverlay();
    else gridApi?.hideOverlay();
  }, [gridApi, gridError, gridLoading, rowData.length]);

  const EditModelDetailsRightScreen = () => {
    switch (activeName) {

      case "0-Setup":
        return <>{
          modelDetailData && modelDetailData && <StageOne header={activeName} modelData={modelDetailData.model_details} refreshEditScreen={refreshEditScreen} handleClose={handleClose}
            createNewModel={createNewModel} />}
          {createNewModel && <StageOne header={activeName} modelData={{}} refreshEditScreen={refreshEditScreen} handleClose={handleClose}
            createNewModel={createNewModel} />}
        </>
      case "1-Prep":
        return <StageTwo header={activeName} />;
      case "2-Labeling":
        return <>{
          modelDetailData && modelDetailData && modelDetailData.model_details[0].stage && <StageWithQuestions header={activeName} modelData={modelDetailData.model_details} stageData={modelDetailData.model_details[0].stage[2]} refreshEditScreen={refreshEditScreen}  handleClose={handleClose}/>
        }</>;
      case "3-Tuning":
        return <>{
          modelDetailData && modelDetailData && modelDetailData.model_details[0].stage && <StageWithQuestions header={activeName} modelData={modelDetailData.model_details} stageData={modelDetailData.model_details[0].stage[3]} refreshEditScreen={refreshEditScreen} handleClose={handleClose} />
        }</>;
      case "4-Delivery":
        return <StageTwo header={activeName} />;
      case "Set Active Stage":
        return <SetActiveStage header={activeName} modelData={modelDetailData.model_details} refreshEditScreen={refreshEditScreen} handleClose={handleClose} />;
      default:
        return <div><StageTwo header={activeName} /></div>;
    }
  }

  const EditModelDetails = () => {

    return (
      <>
        {editLoading ? <Loader text='Fetching details...' minHeight="20vh"
          max-height="50vh"
          overlayColor="transparent" />
          :
          <SidebarLayout collapsed={false}>
            <SidebarLayout.Sidebar>
              {!createNewModel &&
                modelDetailData && modelDetailData.model_details[0].stage.map((stageObj: any, id: any) => {
                  return (
                    <SidebarLayout.Sidebar.Item
                      content={`${id}-${stageObj.stage_name}`}
                      activeName={activeName}
                      name={`${id}-${stageObj.stage_name}`}
                      onClick={() => setActiveName(`${id}-${stageObj.stage_name}`)}
                      className='tab1 labeling'
                      badge={stageObj.is_active === true ? "active" : ""}
                      badgeColor="green"
                    />
                  )
                })
              }
              {
                createNewModel &&
                <SidebarLayout.Sidebar.Item
                  content={`0-Setup`}
                  activeName={activeName}
                  name={`0-Setup`}
                  onClick={() => setActiveName(`0-Setup`)}
                  className='tab1'
                  badge={"active"}
                  badgeColor="green"
                />
              }
              {!createNewModel &&
                <SidebarLayout.Sidebar.Item
                  content="Set Active Stage"
                  activeName={activeName}
                  name="Set Active Stage"
                  onClick={() => setActiveName('Set Active Stage')}
                  className='tab1'
                  badge=""
                />
              }
            </SidebarLayout.Sidebar>
            <SidebarLayout.Content>
              <EditModelDetailsRightScreen />
            </SidebarLayout.Content>
          </SidebarLayout>
        }
      </>
    )
  }

  return (
       <div className='edit-context-list-container' style={{marginTop: '80px'}}>
  
      <div className='create-new-model'>

        <Button
          className='context-edit-btn custom-btn'
          content={'Add New Model'}
          disabled={createNewModel}
          size='small'
          textTransform={false}
          onClick={onCreateNewModel}
        />
      </div>
      {/* <Tooltip 
          content="Please click here to download model user guide"
          element={  <a className="tooltip-container" href="https://honeywellprod.sharepoint.com/:b:/t/CAM2/EcyVEflYT_ZHoR7rDGBrC3MBCtx_BAEw6695c1Ebur9kcA?e=snYUf8" target="_blank">
           <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="30px" height="30px"><path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"/></svg>
             </a>
          }
        ></Tooltip> */}

      {!modalOpen && <div className='context-table'>
        <div className='ag-theme-alpine'>
          <AgGridReact
            ref={gridRef}
            domLayout={'autoHeight'}
            rowData={rowData}
            frameworkComponents={{
              StatusRenderer: StatusRenderer,
              ActionRender: ActionRender,
              ActionSetup: ActionSetup,
              ActionLabeling: ActionLabeling,
              ActionTuning: ActionTuning,
              // ActionDisabled:ActionDisabled,
              ActionDelivery: ActionDelivery,
              CustomOverlay: CustomOverlay,
            }}
            rowDataChangeDetectionStrategy={
              ChangeDetectionStrategyType.IdentityCheck
            }
            columnDefs={[
              {
                field: 'model_name',
                headerName: 'Model Name',
                maxWidth: 350,
                minWidth: 350
              },
              {
                field: 'active_stage',
                headerName: 'Active Stage',
                // cellClass: 'align-cell',
                minWidth: 30,
              },
              {
                field: 'module_name',
                headerName: 'Domain',
                // cellClass: 'align-cell',
                minWidth: 70,
              },
              {
                field: 'actions',
                headerName: 'Actions',
                cellRenderer: 'ActionRender',
              },
              {
                field: 'actions',
                headerName: 'Setup',
                cellRenderer: 'ActionSetup',
              },
              {
                field: 'actions',
                headerName: 'Labeling',
                cellRenderer: 'ActionLabeling',
              },
              {
                field: 'actions',
                headerName: 'Tuning',
                cellRenderer: 'ActionTuning',
              },
              {
                field: 'actions',
                headerName: 'Delivery',
                cellRenderer: 'ActionDelivery',
              },
            ]}
            defaultColDef={{
              flex: 1,
              resizable: true,
              sortable: true,
              minWidth: 50,
            }}
            suppressPaginationPanel={true}
            onGridReady={onGridReady}
            overlayLoadingTemplate={'Loading...'}
            noRowsOverlayComponent={'CustomOverlay'}
            noRowsOverlayComponentParams={CustomOverlayParams}
          />
          <Pagination
            totalItems={total_row_count}
            itemsPerPage={page_limit}
            activePage={page}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      }
      {modalOpen && (
        <div><EditModelDetails /></div>)}
      {
        demoModelOpen && <DataContextModal
          open={true}
          onClose={handleDemoPopUpClose}
          modalHeader={highLevelModalData?.model_name ?? ''}
          uniqueId={demouniqueID ?? null}
          statgeId={demoStageID ?? null}
          modelId={highLevelModalData?.model_id}
          isDemo={true}
        />
      }
    </div>
  );
};

export default EditContextList;